export var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Space"] = 32] = "Space";
    KeyCode[KeyCode["LeftArrow"] = 37] = "LeftArrow";
    KeyCode[KeyCode["RightArrow"] = 39] = "RightArrow";
})(KeyCode || (KeyCode = {}));
//# sourceMappingURL=CoherenceConstants.js.map